import { render, staticRenderFns } from "./RemindAllDate.vue?vue&type=template&id=47c1887f&scoped=true"
import script from "./RemindAllDate.vue?vue&type=script&lang=js"
export * from "./RemindAllDate.vue?vue&type=script&lang=js"
import style0 from "./RemindAllDate.vue?vue&type=style&index=0&id=47c1887f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c1887f",
  null
  
)

export default component.exports